import { SHOW_FAILED_UPDATE_OFFER_MODAL, HIDE_FAILED_UPDATE_OFFER_MODAL } from '../types/orders';

export const showFailedUpdateOfferModal = () => ({
    type: SHOW_FAILED_UPDATE_OFFER_MODAL
});

export const hideFailedUpdateOfferModal = () => ({
    type: HIDE_FAILED_UPDATE_OFFER_MODAL
});
